export const merryChatLabelTypes = [
  "count",
  "dot",
  "complete",
  "question",
  "progress",
] as const;

export type MerryChatLabelType = (typeof merryChatLabelTypes)[number];

export const merryChatLabelSizes = [16, 14] as const;

export type MerryChatLabelSize = (typeof merryChatLabelSizes)[number];

const figmaNodeIds: Record<
  MerryChatLabelType,
  Record<MerryChatLabelSize, string>
> = {
  count: {
    14: "300:33044",
    16: "178:10909",
  },
  dot: {
    14: "300:33052",
    16: "178:10911",
  },
  complete: {
    14: "300:33046",
    16: "179:9489",
  },
  question: {
    14: "300:33048",
    16: "179:9493",
  },
  progress: {
    14: "300:33050",
    16: "179:9503",
  },
};

export function getMerryChatLabelFigmaNodeId(
  type: MerryChatLabelType,
  size: MerryChatLabelSize,
) {
  return figmaNodeIds[type][size];
}

export function getMerryChatLabelTextFigmaNodeId(
  size: MerryChatLabelSize,
) {
  return size === 16 ? "178:10907" : "300:33045";
}
